import Lang from "@components/Lang/Lang";

/**
 * 获取列表url
 * @param orderType
 * @return {string}
 */
export function getListUrl(orderType){
    let url = '';
    switch (orderType) {
        case 'load':
            url = '/service/mg/con/report/loadContainer/list';
            break;
        case 'trucking':
            url = '/service/mg/con/report/truckingOrder/list';
            break;
    }
    return url;
}

/**
 * 获取标题
 * @param orderType
 * @return {string}
 */
export function getTitle(orderType){
    let title = '';
    switch (orderType) {
        case 'load':
            title = Lang({id: 'ZhuangXiangDan', default: '装箱单'});
            break;
        case 'trucking':
            title = Lang({id: 'SuiCheDan', default: '随车单'});
            break;
    }
    return title;
}

/**
 * 获取表格滚动条
 * @param orderType
 * @return {string}
 */
export function getScroll(orderType){
    let scroll = '';
    switch (orderType) {
        case 'load':
            scroll = {x:4500,y:450};
            break;
        case 'trucking':
            scroll = {y:400};
            break;
    }
    return scroll;
}


/**
 * 获取下载链接
 * @param orderType
 * @param type
 * @return {string}
 */
export function getDownUrl(orderType,type) {
    let url = '';
    switch (orderType) {
        case 'load':
            url = type==1?'/service/mg/con/report/download/loadContainerOrderExcel':'/service/mg/con/report/download/loadContainerOrderPDF';
            break;
        case 'trucking':
            url = type==1?'/service/mg/con/report/download/truckingOrderExcel':'/service/mg/con/report/download/truckingOrderPDF';
            break;
    }
    return url;
}


/**
 * 获取确认链接
 * @param orderType
 * @return {string}
 */
export function getConfirmContainerOrderUrl(orderType) {
    let url = '';
    switch (orderType) {
        case 'load': //装箱单
            url = '/service/mg/con/report/confirm/loadContainerOrder';
            break;
        case 'trucking'://随车单
            url = '/service/mg/con/report/confirm/truckingOrder';
            break;
        case 'freight'://运费单
            url = '/service/mg/con/report/freight-order/confirm';
            break;
        case 'freight_pay'://付款单确认
            url = '/service/mg/con/report/freight-pay_order/confirm';
            break;
        case 'letter'://海关信函
            url = '/service/mg/con/report/customs-letter/confirm';
            break;
        case 'price'://价格表
            url = '/service/mg/con/report/price-order/confirm';
            break;
        case 'goods'://商品表
            url = '/service/mg/con/report/goods-order/confirm';
            break;
        case 'load_sub'://样品装箱单
            url = '/service/mg/con/report/confirm/loadContainerSubOrder';
            break;
        case 'trucking_sub'://样品随车单
            url = '/service/mg/con/report/confirm/truckingSubOrder';
            break;
        case 'goods_sub'://样品商品表
            url = '/service/mg/con/report/goods-sub-order/confirm';
            break;
    }
    return url;
}
